module.exports = __webpack_public_path__ + "img/header-logo.f27a7cdb.png";